var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-none"},[_c('div',[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-none1"}})])]),_c('span',[_vm._v("暂无数据")])])}
var staticRenderFns = []

export { render, staticRenderFns }